import { Navigate } from "react-router-dom";
import UserLogin from "../pages/UserLogin";
import UserRegistration from "../pages/UserRegistration";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";

export const PublicRoute = () => {
  return [
    // {
    //   path: "/",
    //   element: <UserRegistration />,
    // },
    {
      path: "admin-login",
      element: <UserLogin />,
    },
    // {
    //   path: "admin-registration",
    //   element: <UserRegistration />,
    // },

    {
      path: "forgot-password",
      element: <ForgotPassword />,
    },

    {
      path: "reset-password",
      element: <ResetPassword />,
    },

    {
      path: "*",
      element: <Navigate to="/admin-login" />,
    },
  ];
};
